import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarDetailPasienAdmin from "../../components/TopBarDetailPasienAdmin";
import DetailPasienAdmin from "../../components/DetailPasienAdmin";
import "../../CSS/SemuaDataPasienTK.css";

function HalamanDetailPasienAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarDetailPasienAdmin />

        {/* Konten utama */}
        <div className="main-content-pasien">
          <DetailPasienAdmin />
        </div>
      </div>
    </div>
  );
}

export default HalamanDetailPasienAdmin;
